var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showModal)?_c('main-modal',{attrs:{"title":_vm.$t('delivery.create_setting')},on:{"closeModal":_vm.closeModal}},[_c('manage-setting',{ref:"ManageSetting",attrs:{"type":_vm.type,"selectedRecord":_vm.selectedRecord},on:{"closeModal":_vm.closeModal,"formCompleted":() => { _vm.$emit('formCompleted') }}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }